import { buttonProperties, classNamesFunction, getNativeProps, Icon, } from '@fluentui/react';
import { useSimpleId } from '@m365-admin/hook.use-id';
import { useControlledUncontrolled } from '@m365-admin/utilities';
import * as React from 'react';
const getClassNames = classNamesFunction();
const onRenderTitleDefault = (props) => (React.createElement(React.Fragment, null, props?.title));
export const CollapsibleBase = (props) => {
    const { ariaLabel, children, disabled = false, iconProps, isRequired = false, onClick, onRenderTitle = onRenderTitleDefault, onToggle, renderHeaderAs: HeaderAs = 'h2', styles, theme = {}, } = props;
    // Expanding and collapsing logic.
    const [isExpanded = false, setIsExpanded] = useControlledUncontrolled(props, 'isExpanded', 'defaultIsExpanded', false);
    const handleOnToggle = (e) => {
        const newIsExpanded = !isExpanded;
        setIsExpanded(newIsExpanded);
        onToggle?.(newIsExpanded);
        onClick?.(e);
    };
    // Setting unique id’s to bind the content to the header.
    const collapsibleId = useSimpleId();
    const contentId = `collapsible-content_${collapsibleId}`;
    const headerId = `collapsible-header_${collapsibleId}`;
    /**
     * Getting the native button props to spread into the internal button. Removing `title` from native props, because otherwise it would be applied to the button as native button attribute. If no text is available to the screen-reader inside the button, consumers should take advantage of the `ariaLabel` prop.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, ...nativeProps } = getNativeProps(props, buttonProperties);
    // Determining if a custom icon was passed in, and respect it.
    const iconName = iconProps?.iconName ?? 'ChevronDownMed';
    // Styles
    const classNames = getClassNames(styles, { isExpanded, isRequired, disabled, theme });
    return (React.createElement("div", { className: classNames.root },
        React.createElement(HeaderAs, { className: classNames.headerContainer },
            React.createElement("button", { ...nativeProps, id: headerId, className: classNames.headerButton, "aria-controls": contentId, "aria-expanded": isExpanded, onClick: handleOnToggle, "aria-label": ariaLabel },
                React.createElement("div", { className: classNames.titleContainer }, onRenderTitle(props, onRenderTitleDefault)),
                React.createElement("div", { className: classNames.requiredMarker }),
                React.createElement("div", { className: classNames.headerSpacer }),
                React.createElement(Icon, { ...iconProps, iconName: iconName, "aria-hidden": "true", className: classNames.icon }))),
        isExpanded && (React.createElement("section", { id: contentId, "aria-labelledby": headerId, className: classNames.content }, children))));
};
//# sourceMappingURL=collapsible.base.js.map